module.exports = __webpack_public_path__ + "img/gb6178_1986.prt.e7b70a95.jpg";